import { useEffect } from 'react';
import posthog from 'posthog-js';

const HEX8 = /^[a-f0-9]{8}$/i;
const HEX6 = /^[a-f0-9]{6}$/i;

const useEarnRewardLogEvents = (): void => {
  useEffect(() => {
    const initData = Telegram.WebApp.initData;

    if (!initData) return;
    const params = new URLSearchParams(initData);
    const startParam = params.get('start_param');

    if (startParam) {
      const [partnerCode, inviterCode] = startParam.split('-');

      if (partnerCode === 'source' && inviterCode) {
        posthog.capture('push_open', {
          utm_source: 'push',
          utm_medium: 'notification',
          utm_campaign: inviterCode,
          utm_term: null,
          utm_content: 'startapp',
          utm_source_platform: 'backend',
          utm_campaign_id: inviterCode,
          utm_creative_format: 'text',
        });

        return;
      }

      if (partnerCode && HEX8.test(partnerCode)) {
        if (inviterCode && HEX6.test(inviterCode)) {
          posthog.capture('deeplink_open', {
            utm_source: 'deeplink',
            utm_medium: 'telegram',
            utm_campaign: 'friend_invite',
            utm_content: 'startapp',
            utm_source_platform: 'telegram',
            utm_campaign_id: `friend_${partnerCode}`,
            utm_creative_format: 'link',
            partner_code: partnerCode,
            inviter_code: inviterCode,
          });
        } else {
          posthog.capture('deeplink_open', {
            utm_source: 'deeplink',
            utm_medium: 'telegram',
            utm_campaign: 'partner_program',
            utm_content: 'startapp',
            utm_source_platform: 'telegram',
            utm_campaign_id: `partner_${partnerCode}`,
            utm_creative_format: 'link',
            partner_code: partnerCode,
          });
        }
      }

      return;
    }
  }, []);
};

export { useEarnRewardLogEvents };
